import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18c6ad6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"margin-left":"12px"} }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Data Vault allows you to download all of your personal data stored by ")
const _hoisted_5 = { class: "login" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" . To access this page, please return to ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" and log in to your account. After logging in, find \"Profile\",and then find \"Hapus Akun\", and then locate the option to remove the account on the \"Profile\" screen. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString($setup.appName), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", null, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString($setup.appName), 1 /* TEXT */),
        _hoisted_6,
        _createElementVNode("span", {
          class: "login",
          onClick: $setup.onLogin
        }, _toDisplayString($setup.appName), 1 /* TEXT */),
        _hoisted_7
      ])
    ])
  ]))
}